module.exports = __webpack_public_path__ + "static/media/1_A1_20.4a7d193b.png";